/**
 * Utility function to migrate old history entries to include date and id
 */
export const migrateHistoryEntries = (history: any[]) => {
  if (!history || !Array.isArray(history)) {
    return [];
  }

  return history.map((entry, index) => {
    // Check if entry already has id and date properties
    if (entry.id && entry.date) {
      return entry;
    }

    // Create a new entry with id and date
    return {
      id: crypto.randomUUID(),
      date: new Date(Date.now() - (index * 24 * 60 * 60 * 1000)).toISOString(), // Create dates spread out by days
      results: entry.results
    };
  });
};
